import { useEffect } from 'react';
import { Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { MarketingNavbar } from './components/marketing/MarketingNavbar';
import { MarketingFooter } from './components/marketing/MarketingFooter';
import { Home } from './pages/Home';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { DataDeletion } from './pages/DataDeletion';
import { ThankYou } from './pages/ThankYou';
import { UseCaseLanding, USE_CASES } from './pages/UseCaseLanding';
import { WhoWeAre } from './pages/WhoWeAre';
import { FrequentlyAskedQuestionsPage } from './pages/FrequentlyAskedQuestionsPage';
import { Chatbot } from './components/Chatbot';

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      window.setTimeout(() => {
        let targetId = hash.slice(1);
        try {
          targetId = decodeURIComponent(targetId);
        } catch {
          // Keep the raw fragment if an external link contains malformed URI encoding.
        }
        const target = document.getElementById(targetId);
        target?.scrollIntoView({ behavior: 'smooth' });
      }, 0);
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return null;
};

const SecondaryRouteFonts = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const selector = 'link[data-ancora-secondary-fonts]';
    const existing = document.head.querySelector<HTMLLinkElement>(selector);
    if (pathname !== '/') {
      if (!existing) {
        const fontLink = document.createElement('link');
        fontLink.rel = 'stylesheet';
        fontLink.href = 'https://fonts.googleapis.com/css2?family=Manrope:wght@500;600;700;800&display=swap';
        fontLink.setAttribute('data-ancora-secondary-fonts', '');
        document.head.appendChild(fontLink);
      }
    } else {
      existing?.remove();
    }
  }, [pathname]);

  return null;
};

function App() {
  useEffect(() => {
    document.body.className = 'bg-[#f6f8f7] text-[#10232d] tw-ready';
  }, []);

  return (
    <>
      <ScrollToTop />
      <SecondaryRouteFonts />
      <div className="flex flex-col min-h-screen bg-[#f6f8f7] font-sans">
        <Routes>
          <Route path="/" element={
            <>
              <MarketingNavbar />
              <main className="flex-grow">
                <Home />
              </main>
              <MarketingFooter />
            </>
          } />

          {/* Redirect routes with scroll */}
          <Route path="/precios" element={<Navigate to="/#pricing" replace />} />
          <Route path="/restaurantes" element={<Navigate to="/#hosteleria" replace />} />
          <Route path="/casos" element={<Navigate to="/#casos" replace />} />
          <Route path="/como-funciona" element={<Navigate to="/#how-it-works" replace />} />
          <Route path="/contacto" element={<Navigate to="/#pricing" replace />} />
          <Route path="/servicios" element={<Navigate to="/#que-hacemos" replace />} />
          <Route path="/comparativa" element={<Navigate to="/#comparativa" replace />} />
          <Route path="/quienes-somos" element={
            <>
              <MarketingNavbar />
              <main className="flex-grow">
                <WhoWeAre />
              </main>
              <MarketingFooter />
            </>
          } />
          <Route path="/preguntas-frecuentes" element={
            <>
              <MarketingNavbar />
              <main className="flex-grow">
                <FrequentlyAskedQuestionsPage />
              </main>
              <MarketingFooter />
            </>
          } />
          <Route path="/sectores" element={<Navigate to="/#hosteleria" replace />} />
          <Route path="/faq" element={<Navigate to="/preguntas-frecuentes" replace />} />
          <Route path="/marketing-ia" element={<Navigate to="/#marketing-ia" replace />} />

          <Route path="/clinicas-centros-agenda" element={
            <>
              <MarketingNavbar />
              <UseCaseLanding useCase={USE_CASES.clinicas} />
              <MarketingFooter />
            </>
          } />
          <Route path="/centros-estetica-belleza" element={
            <>
              <MarketingNavbar />
              <UseCaseLanding useCase={USE_CASES.estetica} />
              <MarketingFooter />
            </>
          } />
          <Route path="/agentes-ventas-ia" element={
            <>
              <MarketingNavbar />
              <UseCaseLanding useCase={USE_CASES.ventas} />
              <MarketingFooter />
            </>
          } />
          <Route path="/integraciones-software-ia" element={
            <>
              <MarketingNavbar />
              <UseCaseLanding useCase={USE_CASES.integraciones} />
              <MarketingFooter />
            </>
          } />
          
          <Route path="/privacidad" element={
            <>
              <MarketingNavbar />
              <main className="flex-grow">
                <PrivacyPolicy />
              </main>
              <MarketingFooter />
            </>
          } />
          <Route path="/privacy" element={
            <>
              <MarketingNavbar />
              <main className="flex-grow">
                <PrivacyPolicy />
              </main>
              <MarketingFooter />
            </>
          } />
          <Route path="/privacy-policy" element={
            <>
              <MarketingNavbar />
              <main className="flex-grow">
                <PrivacyPolicy />
              </main>
              <MarketingFooter />
            </>
          } />
          <Route path="/politica-privacidad" element={
            <>
              <MarketingNavbar />
              <main className="flex-grow">
                <PrivacyPolicy />
              </main>
              <MarketingFooter />
            </>
          } />
          <Route path="/politica-de-privacidad" element={
            <>
              <MarketingNavbar />
              <main className="flex-grow">
                <PrivacyPolicy />
              </main>
              <MarketingFooter />
            </>
          } />
          <Route path="/eliminacion-datos" element={
            <>
              <MarketingNavbar />
              <main className="flex-grow">
                <DataDeletion />
              </main>
              <MarketingFooter />
            </>
          } />
          <Route path="/data-deletion" element={
            <>
              <MarketingNavbar />
              <main className="flex-grow">
                <DataDeletion />
              </main>
              <MarketingFooter />
            </>
          } />
          <Route path="/gracias" element={
            <>
              <MarketingNavbar />
              <main className="flex-grow">
                <ThankYou />
              </main>
              <MarketingFooter />
            </>
          } />
        </Routes>
        
        <Chatbot />
      </div>
    </>
  );
}

export default App;